import { greenToRedPositionsParser } from './greenToRedPositionsParser';
import { bounceEmaParser } from './bounceEmaParser';
import { bounceParser } from './bounceParser';
import { breakEmaParser } from './breakEmaParser';
import { breakParser } from './breakParser';
import { candleBreakParser } from './candleBreakParser';
import { flattenBeforeMarketClosedParser } from './flattenBeforeMarketClosedParser';
import { gapFilterParser } from './gapFilterParser';
import { grabCentsParser } from './grabCentsParser';
import { lossLimitParser } from './lossLimitParser';
import { positionPriceTrailParser } from './positionPriceTrailParser';
import { preserveProfitParser } from './preserveProfitParser';
import { ratchetBracketParser } from './ratchetBracketParser';
import { timeOfDayParser } from './timeOfDayParser';
import { underlyingPriceTrailParser } from './underlyingPriceTrailParser';
import { greenToRedCandlesParser } from './greenToRedCandlesParser';
import { atrTrailParser } from './atrTrailParser';
import { mfeRetracementParser } from './mfeRetracementParser';
import { ftfcFilterParser } from './ftfcFilterParser';
import { priceIntersectsFirstCandleParser } from './priceIntersectsFirstCandleFilter';
import { convictionCandleParser } from './convictionCandleParser';
import { candlePatternParser } from './candlePatternParser';
import { orbParser } from './orbParser';
import { flagParser } from './flagParser';
import { candleTriggerParser } from './candleTriggerParser';
import { breakCandleType } from './breakCandleType';
import { candleTrailParser } from './candleTrailParser';
import { emaIntersectsFirstCandleParser } from './emaIntersectsFirstCandleParser';

const pluginTemplateParsers = {
  CANDLE_BREAK: candleBreakParser,
  MARKET_ORDER: null,
  LIMIT_ORDER: null,
  SCALING_IN: null,
  ADD_TO_WINNER: null,
  FLATTEN_BEFORE_MARKET_CLOSE: flattenBeforeMarketClosedParser,
  GRAB_CENTS: grabCentsParser,
  PRESERVE_PROFIT: preserveProfitParser,
  LOSS_LIMIT: lossLimitParser,
  POSITION_PRICE_TRAIL: positionPriceTrailParser,
  UNDERLYING_PRICE_TRAIL: underlyingPriceTrailParser,
  CANDLE_TRAIL: candleTrailParser,
  GREEN_TO_RED_CANDLES: greenToRedCandlesParser,
  GREEN_TO_RED_POSITIONS: greenToRedPositionsParser,
  BREAK_PRICE: null,
  POSITION_BREAK_PRICE: null,
  RATCHET_BRACKET: ratchetBracketParser,
  CANDLE_MAGNITUDE: null,
  ATR_TRAIL: atrTrailParser,
  MFE_RETRACEMENT: mfeRetracementParser,
  UNDERLYING_PRICE_EXIT: null,
  EMA_INTERSECTS_FIRST_CANDLE: emaIntersectsFirstCandleParser,
  GAP_FILTER: gapFilterParser,
  TIME_OF_DAY: timeOfDayParser,
  FTFC_FILTER: ftfcFilterParser,
  PRICE_INTERSECTS_FIRST_CANDLE: priceIntersectsFirstCandleParser,
  BOUNCE: bounceParser,
  BREAK: breakParser,
  CONVICTION_CANDLE: convictionCandleParser,
  BOUNCE_EMA: bounceEmaParser,
  BREAK_EMA: breakEmaParser,
  CANDLE_PATTERN: candlePatternParser,
  CANDLE_TRIGGER: candleTriggerParser,
  FLAG: flagParser,
  ORB: orbParser,
  BREAK_CANDLE_TYPE: breakCandleType,
};

export function pluginTemplateParser(pluginTemplate, tacticName) {
  const parser = pluginTemplateParsers[tacticName];
  if (parser) {
    return parser(pluginTemplate);
  }
  return null;
}
